import React, { ComponentType } from 'react';
import PaddingBox from '@uds/padding-box';
import { Container, Row, Column, Justify } from '@uds/grid';
import { ImagesWithAspectRatios } from 'core/ribbons/primitives';
import { Alignment } from 'domain/constants/alignment';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { bootstrapResponsiveColumns } from 'presentation/utils/responsiveColumns';
import Ribbon from 'components/ribbons/Ribbon';
import { useBreakpoints } from '@ux/responsive';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';

import Image from './Image';
import useStylesheet from './Filmstrip.stylesheet';

type ItemProps = {
  media: {
    imageUrl: string;
    imageAspectRatio?: ImageAspectRatio;
    imagesWithAspectRatios?: ImagesWithAspectRatios;
  };
};
interface OuterProps extends RibbonProps {
  items: Array<ItemProps>;
}

export const PureFilmstrip = ({ id, colorway, layout, loading, name, items }: OuterProps) => {
  const { styles } = useStylesheet();
  // @ts-ignore: error after upgrading to ux-configs
  const columns = bootstrapResponsiveColumns([2, 3, 6], layout?.columns);
  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.CENTER,
    layout?.alignmentTablet ?? Alignment.CENTER,
    layout?.alignment ?? Alignment.CENTER,
  ]);
  const justify = alignment === Alignment.STARTING ? Justify.FLEX_START : Justify.CENTER;

  return (
    <Ribbon id={id} colorway={colorway} loading={loading} layout={layout} name={name} type={Type.FILMSTRIP}>
      <Container>
        <PaddingBox>
          <div style={styles.row}>
            <Row justify={justify}>
              {items.map((item, i) => (
                <Column key={`Column_${id}_`.concat(String(i))} xs={columns[0]} sm={columns[1]} lg={columns[2]}>
                  <div style={styles.item}>
                    <Image {...item} />
                  </div>
                </Column>
              ))}
            </Row>
          </div>
        </PaddingBox>
      </Container>
    </Ribbon>
  );
};

PureFilmstrip.displayName = 'Filmstrip';

export default errorBoundary(visibilitySet(PureFilmstrip)) as ComponentType<OuterProps>;
